export default "__VITE_ASSET__10019f3f__"